module.exports = __webpack_public_path__ + "img/loading.29f8ce72.gif";